<template>
  <div class="card mb-0">
    <div class="card-header px-3 pb-0 border-bottom-0">
      <h3 class="text-gray-5 font-weight-bold text-uppercase font-size-16">
        {{ title }}
      </h3>
    </div>
    <div class="card-body px-3 pt-0">
      <p
        class="font-weight-bold font-size-28 mb-0"
        :class="'text-' + color"
      >
        {{ result }}/10
      </p>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true
		},
		result: {
			type: Number,
			default: 0
		}
	},
	computed: {
		color() {
			if (this.result < 5) return 'danger';
			if (this.result < 8) return 'primary';

			return 'success';
		}
	}
};
</script>

<style lang="scss" scoped></style>
